<app-dialog
  #dialog
  [action]="'committee-create'"
  [key]="'committee-create'"
  [title]="'Novo Comitê'"
  [headerTheme]="'simple'"
  [hideDefaultFooter]="true"
  [maxWidth]="'900px'"
  [showMaximizeButton]="true"
  [enableScroll]="true"
  [scrollableContent]="true">
  <div class="committee-wizard">
    <!-- Stepper -->
    <div class="committee-wizard__stepper">
      <div
        *ngFor="let step of [1, 2, 3, 4]; let i = index"
        class="committee-wizard__step"
        [class.committee-wizard__step--active]="currentStep === step"
        [class.committee-wizard__step--done]="currentStep > step"
        (click)="goToStep(step)">
        <div class="committee-wizard__step-circle">
          <i *ngIf="currentStep > step" class="pi pi-check"></i>
          <span *ngIf="currentStep <= step">{{ step }}</span>
        </div>
        <span class="committee-wizard__step-label">
          @switch (step) {
            @case (1) {
              Informações
            }
            @case (2) {
              Membros
            }
            @case (3) {
              Regras
            }
            @case (4) {
              Revisão
            }
          }
        </span>
      </div>
    </div>

    <!-- Step 1: Informações Básicas -->
    @if (currentStep === 1) {
      <div class="committee-wizard__content">
        <h3 class="committee-wizard__section-title">Informações Básicas</h3>
        <p class="committee-wizard__section-sub">
          Defina a empresa, os vínculos e o contexto da decisão.
        </p>

        <!-- 1. Empresa -->
        <div class="committee-wizard__field">
          <label class="committee-wizard__label">Empresa *</label>
          @if (prefillLocked) {
            <app-input
              [placeholder]="''"
              [(ngModel)]="companyName"
              [name]="'companyName'"
              [disabled]="true" />
          } @else {
            <app-select-company
              [placeholder]="'Selecione a empresa'"
              (sendSelectedOption)="onCompanySelect($event)" />
          }
        </div>

        <!-- 2. Mandato (visível apenas quando aberto via fluxo de mandato) -->
        @if (mandatePrefilled) {
          <div class="committee-wizard__field">
            <label class="committee-wizard__label">Mandato</label>
            <app-input
              [placeholder]="''"
              [ngModel]="mandateSequentialId ? 'MGR #' + mandateSequentialId : 'MGR'"
              [name]="'mandateLabel'"
              [disabled]="true" />
          </div>
        }

        <!-- 3. Vínculos -->
        <div class="committee-wizard__section-divider">
          <span>Vínculos</span>
        </div>

        <div class="committee-wizard__links-grid">
          <div class="committee-wizard__field">
            <label class="committee-wizard__label">Pipeline Card</label>
            <app-select
              [options]="pipelineOptions"
              [placeholder]="
                companyId ? 'Selecione um card de pipeline' : 'Selecione a empresa primeiro'
              "
              [disabled]="!companyId"
              [isLoading]="isLoadingPipelines"
              [showClear]="true"
              [ngModel]="pipelineCardId"
              (sendSelectedOption)="onPipelineCardSelect($event)" />
          </div>

          <div class="committee-wizard__field">
            <label class="committee-wizard__label">RFQ</label>
            @if (rfqPrefilled || lockNonInstallmentLinks) {
              <app-input
                [placeholder]="''"
                [ngModel]="rfqSequentialId != null ? '#' + rfqSequentialId : '-'"
                [name]="'rfqLabel'"
                [disabled]="true" />
            } @else {
              <app-select
                [options]="rfqOptions"
                [placeholder]="companyId ? 'Selecione um RFQ' : 'Selecione a empresa primeiro'"
                [disabled]="!companyId"
                [isLoading]="isLoadingRfqs"
                [showClear]="true"
                [ngModel]="rfqId"
                (sendSelectedOption)="onRfqSelect($event)" />
            }
          </div>

          <div class="committee-wizard__field">
            <label class="committee-wizard__label">Empréstimo</label>
            <!-- Card 3278: seletor padrão de LOAN; vem selecionado pelo prefill, mas editável -->
            <app-select-loan
              [options]="loanOptions"
              [placeholder]="companyId ? 'Selecione um empréstimo' : 'Selecione a empresa primeiro'"
              [disabled]="!companyId"
              [loading]="isLoadingLoans"
              [showClear]="true"
              [hasFilter]="true"
              [showCompany]="false"
              [standaloneNgModel]="true"
              [ngModelValue]="loanId || null"
              (ngModelValueChange)="onLoanValueChange($event)" />
          </div>

          <div class="committee-wizard__field">
            <label class="committee-wizard__label">Parcela(s)</label>
            @if (installmentPrefilled && !derivativeListMode) {
              <app-input
                [placeholder]="''"
                [ngModel]="'Parcela #' + (installmentNumbers[0] ?? '')"
                [name]="'installmentLabel'"
                [disabled]="true" />
            } @else {
              <app-select
                [options]="installmentOptions"
                [multiple]="true"
                [maxSelectedLabels]="2"
                [placeholder]="loanId ? 'Selecione as parcelas' : 'Selecione o empréstimo primeiro'"
                [disabled]="!loanId"
                [showClear]="true"
                [ngModel]="installmentIds"
                (sendSelectedOptionMultiple)="onInstallmentSelect($event)" />
            }
          </div>

          <div class="committee-wizard__field">
            <label class="committee-wizard__label">
              {{ linkedDerivatives.length > 1 ? 'Derivativos' : 'Derivativo' }}
            </label>
            @if (availableDerivativeOptions.length > 0) {
              <!-- Card 3108: vindo da tela de Derivativos, marque ou desmarque os da demanda -->
              <app-select
                [options]="availableDerivativeOptions"
                [multiple]="true"
                [maxSelectedLabels]="3"
                [placeholder]="'Selecione os derivativos'"
                [isLoading]="isLoadingDerivativeDetails"
                [showClear]="true"
                [ngModel]="linkedDerivativeIds"
                (ngModelChange)="onLinkedDerivativesChange($event)" />
            } @else if (derivativePrefilled || lockNonInstallmentLinks) {
              <app-input
                [placeholder]="''"
                [ngModel]="linkedDerivatives.length ? derivativesLabel : '-'"
                [name]="'derivativeLabel'"
                [disabled]="true" />
            } @else {
              <!-- Card 3278: vários derivativos também no Novo Comitê aberto direto -->
              <app-select
                [options]="visibleDerivativeOptions"
                [multiple]="true"
                [maxSelectedLabels]="2"
                [placeholder]="
                  companyId ? 'Selecione os derivativos' : 'Selecione a empresa primeiro'
                "
                [disabled]="!companyId"
                [isLoading]="isLoadingDerivatives || isLoadingDerivativeDetails"
                [showClear]="true"
                [ngModel]="linkedDerivativeIds"
                (ngModelChange)="onCompanyDerivativesChange($event)" />
            }
          </div>
        </div>

        <!-- 4. Título -->
        <div class="committee-wizard__field">
          <label class="committee-wizard__label">Título *</label>
          <app-input
            [placeholder]="'Título do comitê'"
            [(ngModel)]="title"
            [name]="'title'"
            (ngModelChange)="onTitleInput()" />
          @if (!titleManuallyEdited && (mandatePrefilled || rfqId || loanId || pipelineCardId)) {
            <small class="committee-wizard__field-hint">
              <i class="pi pi-magic-wand"></i>
              Gerado automaticamente com base nos vínculos selecionados
            </small>
          }
        </div>

        <!-- 5. Descrição -->
        <div class="committee-wizard__field">
          <label class="committee-wizard__label">Descrição / Contexto</label>
          <textarea
            class="committee-wizard__textarea"
            rows="4"
            placeholder="Descreva o motivo e o contexto da decisão..."
            [(ngModel)]="description"
            (input)="onDescriptionInput()"></textarea>
        </div>
      </div>
    }

    <!-- Step 2: Seleção de Membros -->
    @if (currentStep === 2) {
      <div class="committee-wizard__content">
        <app-monitoring-user-picklist
          [(members)]="members"
          [companyId]="companyId || null"
          [showCommitteeMemberFields]="true"
          [minMembers]="2"
          [resetVersion]="memberPicklistResetVersion" />
      </div>
    }

    <!-- Step 3: Regras de Aprovação -->
    @if (currentStep === 3) {
      <div class="committee-wizard__content">
        <div class="committee-wizard__rules-grid">
          <!-- Tipo de aprovação -->
          <div class="committee-wizard__rules-left">
            <h3 class="committee-wizard__section-title">Tipo de Aprovação</h3>

            <div
              class="committee-wizard__approval-card"
              [class.committee-wizard__approval-card--selected]="
                approvalType === 'Majority60Percent'
              "
              [class.committee-wizard__approval-card--disabled]="!canUseMajority"
              (click)="canUseMajority && (approvalType = 'Majority60Percent')">
              <div class="committee-wizard__approval-header">
                <i class="pi pi-chart-pie"></i>
                <strong>Maioria de 60%</strong>
                <div
                  class="committee-wizard__approval-radio"
                  [class.committee-wizard__approval-radio--selected]="
                    approvalType === 'Majority60Percent'
                  "></div>
              </div>
              <p>Proposta aprovada quando pelo menos 60% dos votantes aprovam.</p>
            </div>
            @if (!canUseMajority) {
              <small class="committee-wizard__approval-note">
                Disponível apenas com mais de 2 votantes.
              </small>
            }

            <div
              class="committee-wizard__approval-card"
              [class.committee-wizard__approval-card--selected]="approvalType === 'Unanimous'"
              (click)="approvalType = 'Unanimous'">
              <div class="committee-wizard__approval-header">
                <i class="pi pi-shield"></i>
                <strong>Unanimidade</strong>
                <div
                  class="committee-wizard__approval-radio"
                  [class.committee-wizard__approval-radio--selected]="
                    approvalType === 'Unanimous'
                  "></div>
              </div>
              <p>Qualquer rejeição aplica <strong>veto imediato</strong> e encerra a votação.</p>
            </div>

            <div class="committee-wizard__field committee-wizard__field--mt">
              <label class="committee-wizard__label">Prazo para votação *</label>
              <div class="committee-wizard__deadline-row">
                <app-calendar
                  [showTime]="false"
                  [minDate]="today"
                  [(ngModel)]="deadline"
                  [name]="'deadline'"
                  [placeholder]="'Selecione a data'" />
                <input
                  type="time"
                  class="committee-wizard__time-input"
                  [(ngModel)]="deadlineTime"
                  [name]="'deadlineTime'" />
              </div>
              @if (deadline && !isDeadlineFuture) {
                <small class="committee-wizard__field-error">
                  <i class="pi pi-exclamation-circle"></i>
                  O prazo deve ser uma data e hora futura.
                </small>
              }
            </div>
          </div>

          <!-- Preview da simulação -->
          <div class="committee-wizard__preview-panel">
            <h3 class="committee-wizard__section-title">Preview de Quórum</h3>

            <div class="committee-wizard__preview-stat">
              <span>Votantes</span>
              <strong>{{ voterCount }}</strong>
            </div>

            <div class="committee-wizard__preview-stat">
              <span>Mínimo para aprovação</span>
              <strong>{{ approvalThreshold }}</strong>
            </div>

            <div class="committee-wizard__preview-rule">
              @if (approvalType === 'Majority60Percent') {
                <p>
                  <i class="pi pi-info-circle"></i>
                  <span>
                    Serão necessários ao menos <strong>{{ approvalThreshold }}</strong> de
                    <strong>{{ voterCount }}</strong> votos favoráveis para aprovação.
                  </span>
                </p>
              } @else {
                <p>
                  <i class="pi pi-exclamation-triangle"></i>
                  <span>
                    Todos os <strong>{{ voterCount }}</strong> votantes precisam aprovar. Um único
                    voto de rejeição aplica <strong>veto imediato</strong>.
                  </span>
                </p>
              }
            </div>

            <div class="committee-wizard__preview-voters">
              @for (member of members; track member.userId) {
                @if (member.hasVotingPower) {
                  <div class="committee-wizard__preview-voter">
                    <div class="committee-wizard__user-avatar committee-wizard__user-avatar--sm">
                      {{ member.displayName?.charAt(0) }}
                    </div>
                    <span>{{ member.displayName }}</span>
                    @if (member.roleLabel) {
                      <small>{{ member.roleLabel }}</small>
                    }
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Step 4: Revisão Final -->
    @if (currentStep === 4) {
      <div class="committee-wizard__content">
        <h3 class="committee-wizard__section-title">Revisão Final</h3>
        <p class="committee-wizard__section-sub">Confirme os dados antes de criar o comitê.</p>

        <div class="committee-wizard__review-grid">
          <!-- Dados gerais -->
          <div class="committee-wizard__review-card">
            <h4>Informações Gerais</h4>
            <div class="committee-wizard__review-row">
              <span>Título</span>
              <strong>{{ title }}</strong>
            </div>
            <div class="committee-wizard__review-row">
              <span>Empresa</span>
              <strong>{{ companyName }}</strong>
            </div>
            @if (mandatePrefilled && mandateSequentialId) {
              <div class="committee-wizard__review-row">
                <span>Mandato</span>
                <strong>MGR #{{ mandateSequentialId }}</strong>
              </div>
            }
            @if (pipelineCardId) {
              <div class="committee-wizard__review-row">
                <span>Pipeline Card</span>
                <strong>{{ pipelineCardRef }}</strong>
              </div>
            }
            @if (rfqSequentialId != null) {
              <div class="committee-wizard__review-row">
                <span>RFQ</span>
                <strong>#{{ rfqSequentialId }}</strong>
              </div>
            }
            @if (loanContractId) {
              <div class="committee-wizard__review-row">
                <span>Empréstimo</span>
                <strong>{{ loanContractId }}</strong>
              </div>
            }
            @if (installmentNumbers.length > 0) {
              <div class="committee-wizard__review-row">
                <span>{{ installmentNumbers.length > 1 ? 'Parcelas' : 'Parcela' }}</span>
                <strong>{{ installmentNumbersLabel }}</strong>
              </div>
            }
            @if (linkedDerivatives.length > 0) {
              <div class="committee-wizard__review-row">
                <span>{{ linkedDerivatives.length > 1 ? 'Derivativos' : 'Derivativo' }}</span>
                <strong>{{ derivativesLabel }}</strong>
              </div>
            }
            @if (description) {
              <div class="committee-wizard__review-row">
                <span>Descrição</span>
                <p class="committee-wizard__review-desc">{{ description }}</p>
              </div>
            }
          </div>

          <!-- Regras -->
          <div class="committee-wizard__review-card">
            <h4>Regras de Aprovação</h4>
            <div class="committee-wizard__review-row">
              <span>Tipo</span>
              <strong>
                {{ approvalType === 'Majority60Percent' ? 'Maioria 60%' : 'Unanimidade' }}
              </strong>
            </div>
            <div class="committee-wizard__review-row">
              <span>Prazo</span>
              <strong>{{ formatDeadlineLabel() }}</strong>
            </div>
            <div class="committee-wizard__review-row">
              <span>Votantes</span>
              <strong>{{ voterCount }}</strong>
            </div>
            <div class="committee-wizard__review-row">
              <span>Mínimo aprovações</span>
              <strong>{{ approvalThreshold }}</strong>
            </div>
          </div>

          <!-- Membros -->
          <div class="committee-wizard__review-card committee-wizard__review-card--full">
            <h4>Composição do Colegiado ({{ members.length }} membros)</h4>
            <div class="committee-wizard__review-members">
              @for (member of members; track member.userId) {
                <div class="committee-wizard__review-member">
                  <div class="committee-wizard__user-avatar committee-wizard__user-avatar--sm">
                    {{ member.displayName?.charAt(0) }}
                  </div>
                  <div>
                    <span>{{ member.displayName }}</span>
                    @if (member.roleLabel) {
                      <small>{{ member.roleLabel }}</small>
                    }
                  </div>
                  <span
                    class="committee-wizard__member-badge"
                    [class.committee-wizard__member-badge--voter]="member.hasVotingPower"
                    [class.committee-wizard__member-badge--observer]="!member.hasVotingPower">
                    {{ member.hasVotingPower ? 'Votante' : 'Observador' }}
                  </span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Footer do wizard -->
    <div class="committee-wizard__footer">
      <div class="committee-wizard__footer-left">
        @if (currentStep > 1) {
          <app-button
            [label]="'Voltar'"
            type="button"
            [outlined]="true"
            (sendButtonClick)="prevStep()" />
        }
      </div>
      <div class="committee-wizard__footer-right">
        @if (currentStep < 4) {
          <app-button
            [label]="'Próximo'"
            type="button"
            [disabled]="!stepValid"
            (sendButtonClick)="nextStep()" />
        } @else {
          <app-button
            [label]="isSubmitting ? 'Criando...' : 'Criar Comitê'"
            type="button"
            [disabled]="isSubmitting || !hasAtLeastOneVoter"
            [isLoading]="isSubmitting"
            (sendButtonClick)="submit()" />
        }
      </div>
    </div>
  </div>
</app-dialog>
